import { render } from "./users-page.vue?vue&type=template&id=6a4d98f0&ts=true"
import script from "./users-page.vue?vue&type=script&lang=ts"
export * from "./users-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__